import { z } from 'zod';

export const WalletTransactionTypeSchema = z.enum([
  'REFERRAL_CREDIT',
  'MILESTONE_BONUS',
  'BOOKING_DEBIT',
  'ADMIN_CREDIT',
  'ADMIN_DEBIT',
  'EXPIRED',
]);

export type WalletTransactionType = z.infer<typeof WalletTransactionTypeSchema>;

export const WalletSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  balance: z.number().nonnegative(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type Wallet = z.infer<typeof WalletSchema>;

export const WalletTransactionSchema = z.object({
  id: z.string().uuid(),
  walletId: z.string().uuid(),
  type: WalletTransactionTypeSchema,
  amount: z.number(),
  description: z.string().optional(),
  referralId: z.string().uuid().optional(),
  bookingId: z.string().uuid().optional(),
  expiresAt: z.string().datetime().optional(),
  expiredAt: z.string().datetime().optional(),
  createdAt: z.string().datetime(),
});

export type WalletTransaction = z.infer<typeof WalletTransactionSchema>;

export const WalletBalanceResponseSchema = z.object({
  balance: z.number().nonnegative(),
  expiringCredits: z
    .object({
      amount: z.number(),
      expiresAt: z.string().datetime(),
    })
    .optional(),
});

export type WalletBalanceResponse = z.infer<typeof WalletBalanceResponseSchema>;

export const WalletTransactionsResponseSchema = z.object({
  transactions: z.array(WalletTransactionSchema),
  pagination: z.object({
    page: z.number(),
    limit: z.number(),
    total: z.number(),
  }),
});

export type WalletTransactionsResponse = z.infer<
  typeof WalletTransactionsResponseSchema
>;
